import PrimeReact from 'primereact/api'
import { useMountEffect } from 'primereact/hooks'
import { classNames } from 'primereact/utils'
import React, { useContext, useRef } from 'react'
import { LayoutContext } from './context/layoutcontext'
import type { ChildContainerProps } from '../../types/types'

const Layout = (props: ChildContainerProps) => {
    const { layoutConfig, layoutState } = useContext(LayoutContext)

    useMountEffect(() => {
        PrimeReact.ripple = true
    })

    const containerClass = classNames({
        'layout-light': layoutConfig.colorScheme === 'light',
        'layout-dim': layoutConfig.colorScheme === 'dim',
        'layout-dark': layoutConfig.colorScheme === 'dark',
        'layout-colorscheme-menu': layoutConfig.menuTheme === 'colorScheme',
        'layout-primarycolor-menu': layoutConfig.menuTheme === 'primaryColor',
        'layout-transparent-menu': layoutConfig.menuTheme === 'transparent',
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-static': layoutConfig.menuMode === 'static',
        'layout-slim': layoutConfig.menuMode === 'slim',
        'layout-slim-plus': layoutConfig.menuMode === 'slim-plus',
        'layout-horizontal': layoutConfig.menuMode === 'horizontal',
        'layout-reveal': layoutConfig.menuMode === 'reveal',
        'layout-drawer': layoutConfig.menuMode === 'drawer',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.staticMenuMobileActive,
        'p-input-filled': layoutConfig.inputStyle === 'filled',
        'p-ripple-disabled': !layoutConfig.ripple,
        'layout-sidebar-active': layoutState.sidebarActive,
        'layout-sidebar-anchored': layoutState.anchored,
    })

    return (
        <React.Fragment>
            <div className={classNames('layout-container', containerClass)}>{props.children}</div>
        </React.Fragment>
    )
}

export default Layout
